import React from 'react'
import './css/AboutUsInfo.css'

export default function AboutUsInfo() {
  return (
    <div className='about-us-quote sectionPadding' style={{ padding:" 8rem 0 6rem 0 " }}>
      <div className='customcontainer'>
        <h2 className="quote-title" data-aos="fade-up">“ करुणा से कर्म, सेवा से धर्म ”</h2>

        <div className='about-us-description'>
          {/* Section 1: Origin & Philosophy */}
          <p data-aos="fade-up">
           Veer Samyak Foundation was born in 2019 from a singular, profound conviction: that every life deserves a foundation of dignity. What began as a mission to provide a definitive home for children in transition has evolved into a boundless pursuit of human welfare. Guided by spiritual inspiration and a commitment to "Seva," we transformed a simple dream of shelter into a reality of absolute security and love.
          </p>

          {/* Section 2: The First Mission */}
          <p data-aos="fade-up">
           We believe that the most significant impacts are often the quietest. What started as a single step has grown into a much bigger mission. Seeing the smiles of children in their new home gave us the strength to go further. Today, we work wherever there is a need, reaching families who often have nowhere else to turn. We believe that our work is not defined by a list of services, but by our commitment to being there whenever a hand is reached out for support.
          </p>

          {/* Section 3: Growth and Impact */}
          <p data-aos="fade-up">
            <strong>
           “In the quiet act of giving, we do not just change lives, we restore the strength of the human spirit.”</strong>
          </p>

          {/* Section 4: Current Initiatives */}
          <p data-aos="fade-up">
          Our work is driven by people—patrons, volunteers, and well-wishers who believe that kindness can truly change the world. It is a tapestry woven by the grace of our mentors and the silent generosity of people like you. Together, we are building a future where hope is a shared inheritance and no one has to walk their path alone.
          </p>

         
        </div>
      </div>
    </div>
  )
}
